import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { select, Store } from '@ngrx/store';
import {
  changePassword,
  changePasswordFormOpened,
  selectChangePasswordErrors,
  selectChangingPassword,
} from '@epicuro-next/state/user-state';
import { map } from 'rxjs/operators';
import {
  BasePasswordFormComponent,
  fieldErrorMap,
  formFieldsArr,
  sharedPasswordValidators,
} from 'password-validations';

@Component({
  selector: 'epc-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ChangePasswordComponent
  extends BasePasswordFormComponent
  implements OnInit
{
  public formFieldsArr = formFieldsArr;
  public fieldErrorMap = fieldErrorMap;

  public changingPassword$ = this.store.pipe(
    select(selectChangingPassword),
    map(Boolean),
  );

  public changePasswordErrors$ = this.store.pipe(
    select(selectChangePasswordErrors),
  );

  public passwordForm: UntypedFormGroup = this.formBuilder.group(
    {
      oldPassword: ['', [Validators.required]],
      newPassword: ['', [Validators.required]],
      confirmPassword: ['', [Validators.required]],
    },
    {
      validators: sharedPasswordValidators,
    },
  );

  constructor(private formBuilder: UntypedFormBuilder, private store: Store) {
    super();
  }

  public ngOnInit() {
    this.store.dispatch(changePasswordFormOpened());
  }

  public handleSubmit(event: MouseEvent) {
    event.preventDefault();

    if (this.passwordForm.valid) {
      this.store.dispatch(
        changePassword({ passwordChangeRequest: this.passwordForm.value }),
      );
      this.passwordForm.reset();
    }
  }
}
